<template>
  <div class="banner-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="btn" @click="handleAddModal('add')">+ 添加协议</div>
        <!-- 表格 -->
        <el-table
          :data="list"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column
            type="index"
            :index="tableIndex"
            align="center"
            label="编号"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="title"
            align="center"
            label="标题"
          ></el-table-column>
          <el-table-column prop="agreementType" align="center" label="协议类型">
            <div slot-scope="scope">
              {{ agreementMap[scope.row.agreementType] }}
            </div>
          </el-table-column>
          <el-table-column
            prop="updated"
            align="center"
            label="编辑时间"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <div
              slot-scope="scope"
              style="display: flex;justify-content: center;"
            >
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="toDelete(scope.row)"
                >
                  删除
                </button>
              </div>
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="toDetail(scope.row)"
                >
                  编辑
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '协议',
      },
      list: [],
      agreement: [],
      agreementMap: {},
    };
  },
  mounted() {
    // 获取列表
    this.getAgreementList();
    this.getDictionaryByName("agreement");
  },
  computed: {},
  methods: {
    // 表格序号
    tableIndex(index) {
      return ++index;
    },
    // 获取轮播列表
    getAgreementList() {
      this.loading++;
      this.httpGet(this.$root.getAgreementList, {}).then(
        (res) => {
          this.loading--;
          this.list = res;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getDictionaryByName(dataName){
      this.loading++;
      this.httpGet(this.$root.getDictionaryByName, {
        dataName
      }).then(
        (res) => {
          this.loading--;
          this[dataName] = res.list;
          let obj = {};
          res.list.forEach(item => {
            obj[item.value] = item.labelName;
          });
          this[dataName + 'Map'] = obj;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    toDetail(row){
      this.$router.push({
        name: 'agreementInfo',
        query: {
          id: row.id
        }
      });
    },
    toDelete(row){
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该协议吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deleteAreement, {
          id: row.id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getAgreementList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    handleAddModal(){
      this.$router.push({
        name: 'agreementInfo',
        query: {
          // title: row.title
        }
      });
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.banner-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
      box-sizing: border-box;
      height: 100%;
      width: 100%;
      overflow-y: auto;
      flex-y(flex-start, flex-start);
      padding: 24px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      .btn {
        // width: 100px;
        display: inline-block;
        padding: 0 10px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
        // margin: 16px 0;
      }

      .table-btn {
        width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
      }
    }
  }
}
</style>
